import React, { Component } from 'react'
import { css } from "@emotion/react"

import { feature } from 'topojson-client'

import Layout from "../components/layout"
import RankingTable from '../components/RankingTable'

// import geoData from '../data/census-geos-100m-resolution.json'
import data from '../data/place-ranking.json'

const titleCss = css`
    font-weight: bold;
    font-size: 1.2em;
`
const noteCss = css`
    font-style: italic;
    font-size: 0.9em;
    margin-bottom: 0.3em;
    margin-top: 0.3em;
`

// const data = feature(geoData, 'places')
// const places = data.features.map(d => d.properties)
//     .filter(d => !d.NAME.includes('CDP'))

const places = data.filter(d => !d.NAME.includes('CDP'))

export default class CountyRankings extends Component {

    render() {
        return <Layout>
            <div css={titleCss}>City and town population change, 2010 to 2020</div>
            <RankingTable rows={places} geoName="Place" />
            <div css={noteCss}>Unncorporated towns omitted.</div>
        </Layout>
    }
}